import { useCallback } from 'react';

import { useModal } from '@kc-console/context';

import { AnnouncementDetailModal, type AnnouncementDetailModalProps } from '../modals';

export interface OpenAnnouncementDetailModalOptions {
  initialAnnouncementId: string;
}

export const useOpenAnnouncementDetailModal = () => {
  const { openModal } = useModal();

  return useCallback(
    ({ initialAnnouncementId }: OpenAnnouncementDetailModalOptions) => {
      openModal<AnnouncementDetailModalProps>({
        Component: AnnouncementDetailModal,
        props: {
          initialAnnouncementId,
        },
      });
    },
    [openModal],
  );
};
